<template>
  <v-container fill-height>
    <v-layout column>
      <v-flex xs12>
        <h1 class="display-1 mb-5 text-xs-center">Register</h1>
        <form novalidate @submit.prevent="whenValid(onSubmit)">
          <v-text-field
            v-model="form.name"
            v-validate="'required|max:50|alpha_spaces'"
            :counter="50"
            :error-messages="errors.collect('name')"
            label="Name"
            data-vv-name="name"
            autofocus
            required
          >
          </v-text-field>
          <v-text-field
            v-model="form.email"
            v-validate="'required|email'"
            :error-messages="errors.collect('email')"
            label="E-mail"
            type="email"
            data-vv-name="email"
            required
          >
          </v-text-field>
          <v-text-field
            ref="password"
            v-model="form.password"
            v-validate="'required|min:8'"
            :error-messages="errors.collect('password')"
            label="Password"
            type="password"
            data-vv-name="password"
            required
          >
          </v-text-field>
          <v-text-field
            v-model="form.password_confirmation"
            v-validate="'required|confirmed:password'"
            :error-messages="errors.collect('password_confirmation')"
            label="Password Confirmation"
            type="password"
            data-vv-name="password_confirmation"
            required
          >
          </v-text-field>
          <v-checkbox
            v-model="form.human"
            v-validate="'required'"
            :error-messages="errors.collect('human')"
            label="I am a real person"
            value="1"
            data-vv-name="human"
            type="checkbox"
            required
          >
          </v-checkbox>
          <v-layout row wrap>
            <v-flex class="text-xs-center mt-5">
              <v-btn
                :disabled="errors.any() || !isComplete"
                large
                color="success"
                type="submit"
                data-test="register-button"
              >
                Sign Up
              </v-btn>
              <v-btn large data-test="register-button" @click="clear">
                clear
              </v-btn>
            </v-flex>
          </v-layout>
          <v-alert
            :value="regError"
            color="error"
            icon="fas fa-exclamation-triangle"
            outline
            class="mt-3"
          >
            {{ regError }}
          </v-alert>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import validate from '../../mixins/validate';
import { register } from '../../api/auth';
import { lowercase } from '../../utils/filters';

export default {
  name: 'Register',
  mixins: [validate],
  $_veeValidate: {
    validator: 'new',
  },
  metaInfo: {
    title: 'Register',
  },
  data() {
    return {
      form: {
        name: '',
        email: lowercase(''),
        password: '',
        password_confirmation: '',
        human: null,
      },
      error: null,
      dictionary: {
        attributes: {
          email: 'E-mail Address',
          password: 'Password',
          password_confirmation: 'Password',
          name: 'Name',
        },
        custom: {
          password: {
            min: 'A minimum of 8 characters are required',
          },
          name: {
            max: 'A maximum of 50 letters are allowed',
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      regError: 'regError',
    }),
    isComplete() {
      return !!(
        this.form.name &&
        this.form.email &&
        this.form.password &&
        this.form.password_confirmation &&
        this.form.human
      );
    },
  },
  mounted() {
    this.$validator.localize('en', this.dictionary);
  },
  methods: {
    ...mapMutations(['showSnackbar', 'closeSnackbar']),
    onSubmit() {
      this.$store.dispatch('register');
      register(this.$data.form)
        .then((res) => {
          this.$store.commit('registrationSuccess', res);
          this.registerSuccess();
          this.clear();
        })
        .then(() => this.$router.push({ path: '/' }))
        .catch((error) => {
          this.$store.commit('registrationFailed', { error });
          this.registerFailed();
        });
    },
    registerSuccess() {
      this.showSnackbar({
        text: 'You have successfully registered!',
        color: 'success',
        timeout: 3000,
      });
    },
    registerFailed() {
      this.showSnackbar({
        text: 'There were problems with your registration credentials!',
        color: 'warning',
        timeout: 3000,
      });
    },
    clear() {
      this.form.name = '';
      this.form.email = '';
      this.form.password = '';
      this.form.password_confirmation = '';
      this.form.human = false;
      this.$validator.reset();
    },
  },
};
</script>

<style scoped>
form {
  max-width: 500px;
  margin: 0 auto;
}
</style>
